import { render, staticRenderFns } from "./NaturalMedicine.vue?vue&type=template&id=036990b8&scoped=true&"
import script from "./NaturalMedicine.vue?vue&type=script&lang=js&"
export * from "./NaturalMedicine.vue?vue&type=script&lang=js&"
import style0 from "./NaturalMedicine.vue?vue&type=style&index=0&id=036990b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036990b8",
  null
  
)

export default component.exports